import React, { useEffect, useState } from 'react';
import './SiteDetails.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';

const SiteDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const siteDetails = location.state?.siteDetails || null;

  const [formData, setFormData] = useState({
    clientName: siteDetails.clientName || '',
    siteName: siteDetails.siteName || '',
    siteAddress: siteDetails.siteAddress || '',
    siteMobile: siteDetails.siteMobile || '',
    siteEmail: siteDetails.siteEmail || '',
    manager: siteDetails.manager || '',
    work_type: siteDetails.work_type || '',
    reference_name: siteDetails.reference_name || '',
    date_of_birth: siteDetails.date_of_birth || '',
    contractNo: siteDetails.contractNo || '',
    registration_date: siteDetails.registration_date || '',
    interior_designer: siteDetails.interior_designer || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const updateSiteDetails = async () => {
    try {
      const response = await axios.put(API_URL + `/client/${siteDetails.siteName}`, formData);

      if (response.status === 200) {
        console.log('Site details updated successfully');
        window.alert('Site details updated successfully!')
        navigate('/SiteDatabase')
      } else {
        console.error('Error updating user');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [clients, setClients] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/client')
      .then(response => response.json())
      .then(data => setClients(data))
      .catch(error => console.error(error));
  }, []);

  let work_type_data;
  let manager_data;
  if(clients && clients.length > 0) {
     work_type_data = clients.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
     manager_data = clients.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }

  return (
    <div className="site_details_page">
      <SideMenuBar />

      <div className="content">
        <NewHeader />

        <main className="site_details_container">
          <section className="site_details_hero">
            <div>
              <span className="site_details_kicker">Site database</span>
              <h1 className="directory_Directory">Site Details</h1>
              <p className="site_details_subtitle">
                Review and update the client, project and site information for this record.
              </p>
            </div>

            <div className="site_identity">
              <span>Current site</span>
              <strong>{formData.siteName || 'Unnamed site'}</strong>
              <small>{formData.clientName || 'No client assigned'}</small>
            </div>
          </section>

          <section className="site_details_panel">
            <header className="site_details_panel_header">
              <div>
                <span className="section_eyebrow">Record information</span>
                <h2>Client &amp; project details</h2>
              </div>
              <span className="site_status_badge">Editable</span>
            </header>

            <form
              className="site_details_form"
              onSubmit={(e) => {
                e.preventDefault();
                updateSiteDetails();
              }}
            >
              <div className="site_details_section">
                <div className="site_details_section_heading">
                  <span className="site_details_section_number">01</span>
                  <div>
                    <h3>Client information</h3>
                    <p>Primary contact information for this project.</p>
                  </div>
                </div>

                <div className="site_details_grid">
                  <div className="site_details_field">
                    <label>Client Name</label>
                    <input
                      placeholder="Enter client name"
                      name="clientName"
                      value={formData.clientName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field">
                    <label>Site Name</label>
                    <input
                      placeholder="Enter site name"
                      name="siteName"
                      value={formData.siteName}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field">
                    <label>Phone No.</label>
                    <input
                      placeholder="Enter phone number"
                      name="siteMobile"
                      value={formData.siteMobile}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field">
                    <label>Email ID</label>
                    <input
                      type="email"
                      placeholder="Enter email address"
                      name="siteEmail"
                      value={formData.siteEmail}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="site_details_divider" />

              <div className="site_details_section">
                <div className="site_details_section_heading">
                  <span className="site_details_section_number">02</span>
                  <div>
                    <h3>Project information</h3>
                    <p>Dates, ownership and commercial references.</p>
                  </div>
                </div>

                <div className="site_details_grid">
                  <div className="site_details_field">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      name="date_of_birth"
                      value={formData.date_of_birth}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field">
                    <label>Registration Date</label>
                    <input
                      type="date"
                      name="registration_date"
                      value={formData.registration_date}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field">
                    <label>Work Type</label>
                    <select
                      name="work_type"
                      value={formData.work_type}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Select work type</option>
                      {(work_type_data || []).map((workType, index) => (
                        <option key={index} value={workType}>
                          {workType}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="site_details_field">
                    <label>Manager</label>
                    <select
                      name="manager"
                      value={formData.manager}
                      onChange={handleInputChange}
                    >
                      <option value="" disabled>Select manager</option>
                      {(manager_data || []).map((manager, index) => (
                        <option key={index} value={manager}>
                          {manager}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="site_details_field">
                    <label>Contract No.</label>
                    <div className="site_readonly_field">
                      <span>{formData.contractNo || 'Not available'}</span>
                      <small>Read only</small>
                    </div>
                  </div>

                  <div className="site_details_field">
                    <label>Referral Name</label>
                    <input
                      placeholder="Enter referral name"
                      name="reference_name"
                      value={formData.reference_name}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field">
                    <label>Interior Designer</label>
                    <input
                      placeholder="Enter interior designer"
                      name="interior_designer"
                      value={formData.interior_designer}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="site_details_field site_details_field_full">
                    <label>Address</label>
                    <textarea
                      placeholder="Enter complete site address"
                      name="siteAddress"
                      value={formData.siteAddress}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <footer className="site_details_form_footer">
                <div>
                  <span className="save_hint">Changes will be saved to the site record.</span>
                </div>
                <button type="submit" className="update_btn_input_SiteDetails">
                  Save changes
                </button>
              </footer>
            </form>
          </section>
        </main>
      </div>
    </div>
  );
};

export default SiteDetails;